"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const DownloadLinks_1 = __importDefault(require("../DownloadLinks"));
const styled_1 = require("./styled");
const NoWallet = () => {
    return (react_1.default.createElement(styled_1.Wrapper, null,
        react_1.default.createElement(styled_1.StyledTitle, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.nowallets-title" })),
        react_1.default.createElement(styled_1.StyledSubtitle, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.nowallets-subtitle" })),
        react_1.default.createElement(DownloadLinks_1.default, null)));
};
exports.default = NoWallet;
//# sourceMappingURL=NoWallet.js.map